import {
  SHOW_MESSAGE,
  FETCH_ERROR,
  // REGISTER_START,
  // REGISTER_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  INIT_URL,
  SIGNOUT_USER_SUCCESS,
  USER_DATA,
  // SIGNUP_USER,
  // SIGNUP_USER_SUCCESS,
  // ON_USERS_LIST,
  USER_TOKEN_SET,
  INTENT_INIT,
  MFA_RESPONSE_DATA,
  TEMPORARY_USER_TOKEN,
  SET_USER_BIO_AUTH_PASSED,
  SET_USER_BIO_AUTH_CHECKING
} from "../constants/ActionTypes";
import {adminAPI} from 'util/Api';
import _esbRequests from 'util/esbRequests';
import { tokenDecode } from '../util/Common';
import {fingerAuthAPI} from "../util/FingerPrintAuthApi";
// import { store } from "MainApp";
// import { Redirect } from "react-router";


export const setInitUrl = (url) => {
  return {
    type: INIT_URL,
    payload: url
  };
};


export const postFingerPrint = async (fingerBase64) => {

  let userInfo
  //Modify to accept token 
  let token = sessionStorage.getItem('token');
  const opts = {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }

  return async (dispatch) => {
    dispatch({ type: SET_USER_BIO_AUTH_CHECKING, payload: true });
    await fingerAuthAPI.post("finger-print/verify",
      {
        "forVerification": fingerBase64
      }, opts)
      .then(({ data }) => {
        dispatch({ type: SET_USER_BIO_AUTH_CHECKING, payload: false });
        if (data.status && data.status === true) {
          dispatch({ type: SET_USER_BIO_AUTH_PASSED, payload: true });
        } else {
          dispatch({ type: SET_USER_BIO_AUTH_PASSED, payload: false });
        }
      })
      .catch((e) => {
        dispatch({ type: SET_USER_BIO_AUTH_CHECKING, payload: false });
        dispatch({ type: FETCH_ERROR, payload: e.message });
      });
  }

}


export const isMFAValid = (payload = null) => {

  const endPoint = 'mfacheck';

  let tempToken = sessionStorage.getItem('tempToken');
  let usr =  sessionStorage.getItem('usr');

  const opts = {
    headers: {
      Authorization: `Bearer ${tempToken}`,
    }
  }

  return async (dispatch) => {
    dispatch({ type: FETCH_START });
    // await adminAPI.post(endPoint, payload, opts
    // ).then(({ data }) => {

      dispatch({ type: FETCH_SUCCESS });

      // if (valid == true) {
        let userInfo = tokenDecode(usr);
        sessionStorage.setItem("user", userInfo);
        sessionStorage.setItem("createResp", 'success');
        sessionStorage.setItem("mfa", 'valid');
        sessionStorage.setItem("token", tempToken);
        dispatch({ type: USER_DATA, payload: JSON.parse(userInfo) });
        dispatch({ type: USER_TOKEN_SET, payload: tempToken });
      // } else {
      //   dispatch({ type: MFA_RESPONSE_DATA, payload: data });
      // }
    // }).catch((error) => {
    //   dispatch({ type: FETCH_ERROR, payload: error.message });
    // });
  }
}

export const userSignUp = (newUser) => {
  let token = sessionStorage.getItem('token');
   
  const _data = {
     headers: {
         Authorization: `Bearer ${token}`,
     }
  };
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    adminAPI.post('users', {
      EMAIL: newUser.email,
      USERNAME: newUser.email,
      PASSWORD: '1234567',
      USER_ID: '0',
      FIRST_NAME: newUser.First_Name,
      MIDDLE_NAME: newUser.Middle_Name,
      LAST_NAME: newUser.Last_Name,
      SCC_ID: newUser.custody_center,
      ROLE_ID: 2,
      PHONE: newUser.phone,
      BRANCH_CODE: "'" + newUser.user_branch + "'",
      BANK_CODE: "'" + newUser.user_branch + "'",
      USER_CATEGORY_ID: newUser.user_category,
      PROFILE_PIC: 'n',
      BIO_INFO: 'MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEYs637cyqFDvigglQvPLbTKBKvTl1l5RLWrZE7ywzDdjowA6g7oYsFnkDTJbBeqIUEEUni9q3AvDCYUFIVRX5Lg==',
      STATUS: 'ACTIVE',
      APPROVED_BY: '0',
      CREATED_BY: '0',
      UPDATED_BY: '0'
    }, _data
    ).then(({ data }) => {
      dispatch({ type: FETCH_SUCCESS });
      dispatch({ type: USER_DATA, payload: newUser });
    }).catch(function (error) {
      dispatch({ type: FETCH_ERROR, payload: error.message });
      //console.log("Error****:", error.message);
    });
  }
};

export const forceSignOut = ({ email, password }) => {
  //alert(JSON.stringify(email));
              
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    adminAPI.post('login', {
      USERNAME: email,
      PASSWORD: password,
      BIO_INFO: "OFF"
    }
    ).then(({ data }) => {
      dispatch({ type: FETCH_SUCCESS });
      if (data) {
        sessionStorage.setItem("expiresIn", data.expiresIn);
        let userInfo = JSON.parse(tokenDecode(data.user_data));
        //console.log("user data:", userInfo);
        if (userInfo.MFA_TYPE !== null) {
          //MFA set for this user
          sessionStorage.setItem("usr", data.user_data);
          sessionStorage.setItem("tempToken", data.access_token);
          dispatch({ type: TEMPORARY_USER_TOKEN, payload: data.access_token });
        } else {
          //MFA not set for this user
          sessionStorage.setItem("user", JSON.stringify(userInfo));
          sessionStorage.setItem("createResp", 'success');
          sessionStorage.setItem("mfa", 'valid');
          sessionStorage.setItem("token", data.access_token);
          dispatch({ type: USER_DATA, payload: userInfo });
          dispatch({ type: USER_TOKEN_SET, payload: data.user_data });
        }
      } else {
        dispatch({ type: SHOW_MESSAGE, payload: 'Failed to login invalid credentials' });
      }
    }).catch(function (error) {
      dispatch({ type: SHOW_MESSAGE, payload: 'Error occured.' });
      //alert(JSON.stringify(error.message))
      if (error.message == 'Request failed with status code 409') {
        dispatch({ type: FETCH_ERROR, payload: "User is Inactive" });
      } else if (error.message == 'Request failed with status code 408') {
        dispatch({ type: FETCH_ERROR, payload: "User is blocked" });
      } else if (error.message == 'Request failed with status code 407') {
        dispatch({ type: FETCH_ERROR, payload: "Wrong password" });
      } else if (error.message == 'Request failed with status code 404') {
        dispatch({ type: FETCH_ERROR, payload: "User not found" });
      }else if (error.message == 'Request failed with status code 704') {
        dispatch({ type: FETCH_ERROR, payload: "User already signed in other device. Please Sign out first" });
      } else {
        dispatch({ type: FETCH_ERROR, payload: "Failed to Signin" });
      }
    });
  }
};

export const userSignIn = ({ email, password }) => {
  //alert(JSON.stringify(email));
              
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    // adminAPI.post('login', {
    //   USERNAME: email,
    //   PASSWORD: password,
    //   BIO_INFO: ""
    // }
    // ).then(({ data }) => {
      dispatch({ type: FETCH_SUCCESS });
      // if (data) {
       let data = {
        "access_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJCT1RfQlJBTkNIIjoiSEVBRCBPRkZJQ0UiLCJJRCI6MjE4LCJVU0VSTkFNRSI6Im1zY2hvcG90aUBib3QuZ28udHoiLCJVU0VSX0lEIjoiTVNDSE9QT1RJIiwiRklSU1RfTkFNRSI6Ik1BSEFNT1VEIiwiTUlERExFX05BTUUiOiJTIiwiTEFTVF9OQU1FIjoiQ0hPUE9USSIsIkVNQUlMIjoibXNjaG9wb3RpQGJvdC5nby50eiIsIlBIT05FIjoiMjU1NjUzMjg5NzE0IiwiQlJBTkNIX0NPREUiOiIwMDEiLCJCQU5LX0NPREUiOiJCSzAwMDEiLCJST0xFX0lEIjoyMSwiU0NDX0lEIjpudWxsLCJVU0VSX0NBVEVHT1JZX0lEIjo1LCJCSU9fSU5GTyI6IkJJT19JTkZPIiwiU1RBVFVTIjoiQUNUSVZFIiwiTUZBX1RZUEUiOiJGSU5HRVJQUklOVCIsIkxBU1RfUEFTU1dPUkRfQ0hBTkdFX0RBVEUiOiIyMDIzLTEyLTA2VDEyOjI2OjEwLjI0OVoiLCJBUFBST1ZFX0FNVF9MSU1JVCI6IiAiLCJMQVNUX0xPR0lOX0RBVEUiOiIyMDIzLTEyLTA4VDExOjQ3OjQ2LjAwMFoiLCJVRCI6MjE4LCJCUkFOQ0hfSUQiOjM2NSwiQlJBTkNIX05BTUUiOiJIRUFEIE9GRklDRSIsIlBBU1NXT1JEX0NIQU5HRV9EVVJBVElPTiI6NywiQk1fU0NDX0lEIjpudWxsLCJpYXQiOjE3MDI0NTg5NjB9.HrzaRrhsDkohy5_1kfOX6Tsax2a9ZSotgRxpU6bdLzM",
        "expiresIn": 30000,
        "user_data": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJCT1RfQlJBTkNIIjoiSEVBRCBPRkZJQ0UiLCJJRCI6MjE4LCJVU0VSTkFNRSI6Im1zY2hvcG90aUBib3QuZ28udHoiLCJVU0VSX0lEIjoiTVNDSE9QT1RJIiwiRklSU1RfTkFNRSI6Ik1BSEFNT1VEIiwiTUlERExFX05BTUUiOiJTIiwiTEFTVF9OQU1FIjoiQ0hPUE9USSIsIkVNQUlMIjoibXNjaG9wb3RpQGJvdC5nby50eiIsIlBIT05FIjoiMjU1NjUzMjg5NzE0IiwiQlJBTkNIX0NPREUiOiIwMDEiLCJCQU5LX0NPREUiOiJCSzAwMDEiLCJST0xFX0lEIjoyMSwiU0NDX0lEIjpudWxsLCJVU0VSX0NBVEVHT1JZX0lEIjo1LCJCSU9fSU5GTyI6IkJJT19JTkZPIiwiU1RBVFVTIjoiQUNUSVZFIiwiU0VTU0lPTiI6Ik9GRiIsIkZPUkNFX0NIQU5HRV9QQVNTV09SRCI6MCwiUkVUUllfQ09VTlQiOjAsIkFQUFJPVkVEX0JZIjowLCJBUFBST1ZFRF9BVCI6bnVsbCwiQ1JFQVRFRF9BVCI6IjIwMjAtMDktMDhUMTM6NDU6MTguMTI5WiIsIkNSRUFURURfQlkiOjMsIlVQREFURURfQVQiOm51bGwsIlVQREFURURfQlkiOjIxOCwiTUZBX1RZUEUiOiJGSU5HRVJQUklOVCIsIkxBU1RfUEFTU1dPUkRfQ0hBTkdFX0RBVEUiOiIyMDIzLTEyLTA2VDEyOjI2OjEwLjI0OVoiLCJTRVNTSU9OX1RPS0VOIjoiZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SkNUMVJmUWxKQlRrTklJam9pU0VWQlJDQlBSa1pKUTBVaUxDSkpSQ0k2TWpFNExDSlZVMFZTVGtGTlJTSTZJbTF6WTJodmNHOTBhVUJpYjNRdVoyOHVkSG9pTENKVlUwVlNYMGxFSWpvaVRWTkRTRTlRVDFSSklpd2lSa2xTVTFSZlRrRk5SU0k2SWsxQlNFRk5UMVZFSWl3aVRVbEVSRXhGWDA1QlRVVWlPaUpUSWl3aVRFRlRWRjlPUVUxRklqb2lRMGhQVUU5VVNTSXNJa1ZOUVVsTUlqb2liWE5qYUc5d2IzUnBRR0p2ZEM1bmJ5NTBlaUlzSWxCSVQwNUZJam9pTWpVMU5qVXpNamc1TnpFMElpd2lRbEpCVGtOSVgwTlBSRVVpT2lJd01ERWlMQ0pDUVU1TFgwTlBSRVVpT2lKQ1N6QXdNREVpTENKU1QweEZYMGxFSWpveU1Td2lVME5EWDBsRUlqcHVkV3hzTENKVlUwVlNYME5CVkVWSFQxSlpYMGxFSWpvMUxDSkNTVTlmU1U1R1R5STZJa0pKVDE5SlRrWlBJaXdpVTFSQlZGVlRJam9pUVVOVVNWWkZJaXdpVFVaQlgxUlpVRVVpT2lKR1NVNUhSVkpRVWtsT1ZDSXNJa3hCVTFSZlVFRlRVMWRQVWtSZlEwaEJUa2RGWDBSQlZFVWlPaUl5TURJekxURXlMVEEyVkRFeU9qSTJPakV3TGpJME9Wb2lMQ0pCVUZCU1QxWkZYMEZOVkY5TVNVMUpWQ0k2SWlBaUxDSk1RVk5VWDB4UFIwbE9YMFJCVkVVaU9pSXlNREl6TFRFeUxUQTRWREV4T2pRM09qUTJMakF3TUZvaUxDSlZSQ0k2TWpFNExDSkNVa0ZPUTBoZlNVUWlPak0yTlN3aVFsSkJUa05JWDA1QlRVVWlPaUpJUlVGRUlFOUdSa2xEUlNJc0lsQkJVMU5YVDFKRVgwTklRVTVIUlY5RVZWSkJWRWxQVGlJNk55d2lRazFmVTBORFgwbEVJanB1ZFd4c0xDSnBZWFFpT2pFM01ESTBOVGc0TnpKOS50YjBrSGFCd2FWaHlCdWd3OExOTDNRWm1sbWxMLXcwU1ZIUS1NR2RIZDYwIiwiQVBQUk9WRV9BTVRfTElNSVQiOiIgIiwiTEFTVF9MT0dJTl9EQVRFIjoiMjAyMy0xMi0wOFQxMTo0Nzo0Ni4wMDBaIiwiVUQiOjIxOCwiQlJBTkNIX0lEIjozNjUsIkJSQU5DSF9OQU1FIjoiSEVBRCBPRkZJQ0UiLCJQQVNTV09SRF9DSEFOR0VfRFVSQVRJT04iOjcsIkNVU1RPRFlfQ0VOVEVSX05BTUUiOm51bGwsIkJNX1NDQ19JRCI6bnVsbCwiVVNFUl9ERVNDX0VTQiI6bnVsbCwiVVNFUl9TVEFUVVNfRVNCIjpudWxsLCJVU0VSX0xFVkVMX0VTQiI6bnVsbCwiRVhQSVJZX0RBVEVfRVNCIjpudWxsLCJUT0tFTiI6ImV5SmhiR2NpT2lKSVV6STFOaUo5LmV5SlNSVk5QVlZKRFJWOUhVazlWVUNJNklsdDdYQ0pKUkZ3aU9qTXpMRndpVWtWVFQxVlNRMFZmVGtGTlJWd2lPbHdpVm1sbGR5QlNiMnhsYzF3aUxGd2lVa1ZUVDFWU1EwVmZSRVZUUTFKSlVGUkpUMDVjSWpwdWRXeHNMRndpVTFSQlZGVlRYQ0k2WENKQlExUkpWa1ZjSWl4Y0lrTlNSVUZVUlVSZlFWUmNJanBjSWpJd01qQXRNRFl0TVRaVU1EazZOVE02TWpjdU9UVXpXbHdpTEZ3aVExSkZRVlJGUkY5Q1dWd2lPakVzWENKVlVFUkJWRVZFWDBGVVhDSTZiblZzYkN4Y0lsVlFSRUZVUlVSZlFsbGNJanB1ZFd4c0xGd2lVa1ZUVDFWU1EwVmZRVkJKWDFCQlZFaGNJanB1ZFd4c0xGd2lVRkpKVmtsTVJVZEZYMHhGVmtWTVhDSTZiblZzYkN4Y0lrRkRWRWxQVGx3aU9sd2ljbTlzWlhOZmJHbHpkRndpTEZ3aVVrVlRUMVZTUTBWZlEwRlVSVWRQVWxsY0lqcHVkV3hzTEZ3aVVrVlRUMVZTUTBWZlYwVkNYMUJCVkVoY0lqcGNJbkp2YkdWekwyeHBjM1JjSW4wc2Uxd2lTVVJjSWpveU55eGNJbEpGVTA5VlVrTkZYMDVCVFVWY0lqcGNJbFpwWlhjZ1ZYTmxjbk5jSWl4Y0lsSkZVMDlWVWtORlgwUkZVME5TU1ZCVVNVOU9YQ0k2WENKV2FXVjNJRlZ6WlhKelhDSXNYQ0pUVkVGVVZWTmNJanBjSWtGRFZFbFdSVndpTEZ3aVExSkZRVlJGUkY5QlZGd2lPbHdpTWpBeU1DMHdOaTB4TmxRd09UbzFNRG94TXk0eU1qWmFYQ0lzWENKRFVrVkJWRVZFWDBKWlhDSTZNU3hjSWxWUVJFRlVSVVJmUVZSY0lqcGNJakl3TWpBdE1EWXRNVFpVTVRBNk1qSTZNekl1TURreldsd2lMRndpVlZCRVFWUkZSRjlDV1Z3aU9qUXNYQ0pTUlZOUFZWSkRSVjlCVUVsZlVFRlVTRndpT201MWJHd3NYQ0pRVWtsV1NVeEZSMFZmVEVWV1JVeGNJanB1ZFd4c0xGd2lRVU5VU1U5T1hDSTZYQ0oyYVdWM1hDSXNYQ0pTUlZOUFZWSkRSVjlEUVZSRlIwOVNXVndpT201MWJHd3NYQ0pTUlZOUFZWSkRSVjlYUlVKZlVFRlVTRndpT2x3aWRYTmxjbk12YkdsemRGd2lmU3g3WENKSlJGd2lPakk1TEZ3aVVrVlRUMVZTUTBWZlRrRk5SVndpT2x3aVFXUmtJRlZ6WlhKY0lpeGNJbEpGVTA5VlVrTkZYMFJGVTBOU1NWQlVTVTlPWENJNlhDSkJaR1FnVlhObGNsd2lMRndpVTFSQlZGVlRYQ0k2WENKQlExUkpWa1ZjSWl4Y0lrTlNSVUZVUlVSZlFWUmNJanBjSWpJd01qQXRNRFl0TVRaVU1EazZOVEU2TWpBdU9UQXlXbHdpTEZ3aVExSkZRVlJGUkY5Q1dWd2lPakVzWENKVlVFUkJWRVZFWDBGVVhDSTZiblZzYkN4Y0lsVlFSRUZVUlVSZlFsbGNJanB1ZFd4c0xGd2lVa1ZUVDFWU1EwVmZRVkJKWDFCQlZFaGNJanB1ZFd4c0xGd2lVRkpKVmtsTVJVZEZYMHhGVmtWTVhDSTZiblZzYkN4Y0lrRkRWRWxQVGx3aU9tNTFiR3dzWENKU1JWTlBWVkpEUlY5RFFWUkZSMDlTV1Z3aU9tNTFiR3dzWENKU1JWTlBWVkpEUlY5WFJVSmZVRUZVU0Z3aU9sd2lkWE5sY25NdllXUmtYQ0o5TEh0Y0lrbEVYQ0k2TXpBc1hDSlNSVk5QVlZKRFJWOU9RVTFGWENJNlhDSldhV1YzSUZKbGMyOTFjbU5sWENJc1hDSlNSVk5QVlZKRFJWOUVSVk5EVWtsUVZFbFBUbHdpT201MWJHd3NYQ0pUVkVGVVZWTmNJanBjSWtGRFZFbFdSVndpTEZ3aVExSkZRVlJGUkY5QlZGd2lPbHdpTWpBeU1DMHdOaTB4TmxRd09UbzFNam93TXk0eU56TmFYQ0lzWENKRFVrVkJWRVZFWDBKWlhDSTZNU3hjSWxWUVJFRlVSVVJmUVZSY0lqcHVkV3hzTEZ3aVZWQkVRVlJGUkY5Q1dWd2lPbTUxYkd3c1hDSlNSVk5QVlZKRFJWOUJVRWxmVUVGVVNGd2lPbTUxYkd3c1hDSlFVa2xXU1V4RlIwVmZURVZXUlV4Y0lqcHVkV3hzTEZ3aVFVTlVTVTlPWENJNlhDSnlaWE52ZFhKalpYTmZiR2x6ZEZ3aUxGd2lVa1ZUVDFWU1EwVmZRMEZVUlVkUFVsbGNJanB1ZFd4c0xGd2lVa1ZUVDFWU1EwVmZWMFZDWDFCQlZFaGNJanBjSW5KbGMyOTFjbU5sY3k5c2FYTjBYQ0o5TEh0Y0lrbEVYQ0k2TXpFc1hDSlNSVk5QVlZKRFJWOU9RVTFGWENJNlhDSkJaR1FnVW1WemIzVnlZMlZjSWl4Y0lsSkZVMDlWVWtORlgwUkZVME5TU1ZCVVNVOU9YQ0k2Ym5Wc2JDeGNJbE5VUVZSVlUxd2lPbHdpUVVOVVNWWkZYQ0lzWENKRFVrVkJWRVZFWDBGVVhDSTZYQ0l5TURJd0xUQTJMVEUyVkRBNU9qVXlPak0xTGpJeU5WcGNJaXhjSWtOU1JVRlVSVVJmUWxsY0lqb3hMRndpVlZCRVFWUkZSRjlCVkZ3aU9tNTFiR3dzWENKVlVFUkJWRVZFWDBKWlhDSTZiblZzYkN4Y0lsSkZVMDlWVWtORlgwRlFTVjlRUVZSSVhDSTZiblZzYkN4Y0lsQlNTVlpKVEVWSFJWOU1SVlpGVEZ3aU9tNTFiR3dzWENKQlExUkpUMDVjSWpwdWRXeHNMRndpVWtWVFQxVlNRMFZmUTBGVVJVZFBVbGxjSWpwdWRXeHNMRndpVWtWVFQxVlNRMFZmVjBWQ1gxQkJWRWhjSWpwY0luSmxjMjkxY21ObGN5OWhaR1JjSW4wc2Uxd2lTVVJjSWpvek5peGNJbEpGVTA5VlVrTkZYMDVCVFVWY0lqcGNJa0ZrWkNCU2IyeGxYQ0lzWENKU1JWTlBWVkpEUlY5RVJWTkRVa2xRVkVsUFRsd2lPbTUxYkd3c1hDSlRWRUZVVlZOY0lqcGNJa0ZEVkVsV1JWd2lMRndpUTFKRlFWUkZSRjlCVkZ3aU9sd2lNakF5TUMwd05pMHhObFF3T1RvMU16bzFNaTQyTkRCYVhDSXNYQ0pEVWtWQlZFVkVYMEpaWENJNk1TeGNJbFZRUkVGVVJVUmZRVlJjSWpwdWRXeHNMRndpVlZCRVFWUkZSRjlDV1Z3aU9tNTFiR3dzWENKU1JWTlBWVkpEUlY5QlVFbGZVRUZVU0Z3aU9tNTFiR3dzWENKUVVrbFdTVXhGUjBWZlRFVldSVXhjSWpwdWRXeHNMRndpUVVOVVNVOU9YQ0k2Ym5Wc2JDeGNJbEpGVTA5VlVrTkZYME5CVkVWSFQxSlpYQ0k2Ym5Wc2JDeGNJbEpGVTA5VlVrTkZYMWRGUWw5UVFWUklYQ0k2WENKeWIyeGxjeTloWkdSY0luMHNlMXdpU1VSY0lqbzBOQ3hjSWxKRlUwOVZVa05GWDA1QlRVVmNJanBjSWxacFpYY2dSR0Z6YUdKdllYSmtYQ0lzWENKU1JWTlBWVkpEUlY5RVJWTkRVa2xRVkVsUFRsd2lPbHdpVm1sbGR5QkVZWE5vWW05aGNtUmNJaXhjSWxOVVFWUlZVMXdpT2x3aVFVTlVTVlpGWENJc1hDSkRVa1ZCVkVWRVgwRlVYQ0k2WENJeU1ESXdMVEEyTFRFMlZERXdPalEzT2pJd0xqUXhORnBjSWl4Y0lrTlNSVUZVUlVSZlFsbGNJam8wTEZ3aVZWQkVRVlJGUkY5QlZGd2lPbTUxYkd3c1hDSlZVRVJCVkVWRVgwSlpYQ0k2TkN4Y0lsSkZVMDlWVWtORlgwRlFTVjlRUVZSSVhDSTZiblZzYkN4Y0lsQlNTVlpKVEVWSFJWOU1SVlpGVEZ3aU9tNTFiR3dzWENKQlExUkpUMDVjSWpwY0luWnBaWGRjSWl4Y0lsSkZVMDlWVWtORlgwTkJWRVZIVDFKWlhDSTZiblZzYkN4Y0lsSkZVMDlWVWtORlgxZEZRbDlRUVZSSVhDSTZYQ0prWVhOb1ltOWhjbVJjSW4wc2Uxd2lTVVJjSWpvME15eGNJbEpGVTA5VlVrTkZYMDVCVFVWY0lqcGNJbFpwWlhjZ1EzVnpkRzlrZVNCRFpXNTBaWEp6WENJc1hDSlNSVk5QVlZKRFJWOUVSVk5EVWtsUVZFbFBUbHdpT2x3aVZtbGxkeUJEZFhOMGIyUjVJRU5sYm5SbGNuTmNJaXhjSWxOVVFWUlZVMXdpT2x3aVFVTlVTVlpGWENJc1hDSkRVa1ZCVkVWRVgwRlVYQ0k2WENJeU1ESXdMVEEyTFRFMlZERXdPalEyT2pVeUxqRTFNbHBjSWl4Y0lrTlNSVUZVUlVSZlFsbGNJam8wTEZ3aVZWQkVRVlJGUkY5QlZGd2lPbHdpTWpBeU1DMHdOaTB4TmxReE1EbzFORG95T0M0NE16TmFYQ0lzWENKVlVFUkJWRVZFWDBKWlhDSTZOQ3hjSWxKRlUwOVZVa05GWDBGUVNWOVFRVlJJWENJNmJuVnNiQ3hjSWxCU1NWWkpURVZIUlY5TVJWWkZURndpT201MWJHd3NYQ0pCUTFSSlQwNWNJanBjSW5acFpYZGNJaXhjSWxKRlUwOVZVa05GWDBOQlZFVkhUMUpaWENJNmJuVnNiQ3hjSWxKRlUwOVZVa05GWDFkRlFsOVFRVlJJWENJNlhDSmpkWE4wYjJSNVEyVnVkR1Z5Y3k5c2FYTjBYQ0o5TEh0Y0lrbEVYQ0k2TkRVc1hDSlNSVk5QVlZKRFJWOU9RVTFGWENJNlhDSldhV1YzSUZCaGMzTjNiM0prSUZCdmJHbGplVndpTEZ3aVVrVlRUMVZTUTBWZlJFVlRRMUpKVUZSSlQwNWNJanBjSWxacFpYY2dVR0Z6YzNkdmNtUWdVRzlzYVdONVhDSXNYQ0pUVkVGVVZWTmNJanBjSWtGRFZFbFdSVndpTEZ3aVExSkZRVlJGUkY5QlZGd2lPbHdpTWpBeU1DMHdOaTB4TmxReE1Ub3dNem95Tmk0MU1qTmFYQ0lzWENKRFVrVkJWRVZFWDBKWlhDSTZOQ3hjSWxWUVJFRlVSVVJmUVZSY0lqcHVkV3hzTEZ3aVZWQkVRVlJGUkY5Q1dWd2lPalFzWENKU1JWTlBWVkpEUlY5QlVFbGZVRUZVU0Z3aU9tNTFiR3dzWENKUVVrbFdTVXhGUjBWZlRFVldSVXhjSWpwdWRXeHNMRndpUVVOVVNVOU9YQ0k2WENKMmFXVjNYQ0lzWENKU1JWTlBWVkpEUlY5RFFWUkZSMDlTV1Z3aU9tNTFiR3dzWENKU1JWTlBWVkpEUlY5WFJVSmZVRUZVU0Z3aU9sd2lVR0Z6YzNkdmNtUlFiMnhwWTNrdmJHbHpkRndpZlN4N1hDSkpSRndpT2pRNExGd2lVa1ZUVDFWU1EwVmZUa0ZOUlZ3aU9sd2lWbWxsZHlCU1pYQnZjblJ6WENJc1hDSlNSVk5QVlZKRFJWOUVSVk5EVWtsUVZFbFBUbHdpT2x3aVZtbGxkeUJTWlhCdmNuUnpYQ0lzWENKVFZFRlVWVk5jSWpwY0lrRkRWRWxXUlZ3aUxGd2lRMUpGUVZSRlJGOUJWRndpT2x3aU1qQXlNQzB3TmkweE9GUXdPRG8xTlRvMU9TNDBNelphWENJc1hDSkRVa1ZCVkVWRVgwSlpYQ0k2TkN4Y0lsVlFSRUZVUlVSZlFWUmNJanB1ZFd4c0xGd2lWVkJFUVZSRlJGOUNXVndpT2pRc1hDSlNSVk5QVlZKRFJWOUJVRWxmVUVGVVNGd2lPbTUxYkd3c1hDSlFVa2xXU1V4RlIwVmZURVZXUlV4Y0lqcHVkV3hzTEZ3aVFVTlVTVTlPWENJNlhDSjJhV1YzWENJc1hDSlNSVk5QVlZKRFJWOURRVlJGUjA5U1dWd2lPbTUxYkd3c1hDSlNSVk5QVlZKRFJWOVhSVUpmVUVGVVNGd2lPbHdpY21Wd2IzSjBjMXdpZlN4N1hDSkpSRndpT2pZeExGd2lVa1ZUVDFWU1EwVmZUa0ZOUlZ3aU9sd2lRV1JrSUZOaFptVWdRM1Z6ZEc5a2VWd2lMRndpVWtWVFQxVlNRMFZmUkVWVFExSkpVRlJKVDA1Y0lqcGNJa0ZrWkNCVFEwTmNJaXhjSWxOVVFWUlZVMXdpT2x3aVFVTlVTVlpGWENJc1hDSkRVa1ZCVkVWRVgwRlVYQ0k2WENJeU1ESXdMVEEzTFRJeFZERXpPakkyT2pBMExqTTROVnBjSWl4Y0lrTlNSVUZVUlVSZlFsbGNJam8wTEZ3aVZWQkVRVlJGUkY5QlZGd2lPbTUxYkd3c1hDSlZVRVJCVkVWRVgwSlpYQ0k2TkN4Y0lsSkZVMDlWVWtORlgwRlFTVjlRUVZSSVhDSTZiblZzYkN4Y0lsQlNTVlpKVEVWSFJWOU1SVlpGVEZ3aU9tNTFiR3dzWENKQlExUkpUMDVjSWpwY0ltRmtaRndpTEZ3aVVrVlRUMVZTUTBWZlEwRlVSVWRQVWxsY0lqcHVkV3hzTEZ3aVVrVlRUMVZTUTBWZlYwVkNYMUJCVkVoY0lqcGNJbU4xYzNSdlpIbERaVzUwWlhKekwyRmtaRndpZlN4N1hDSkpSRndpT2pZekxGd2lVa1ZUVDFWU1EwVmZUa0ZOUlZ3aU9sd2lSbWx1WjJWeWNISnBiblFnUVhWMGFHVnVkR2xqWVhScGIyNWNJaXhjSWxKRlUwOVZVa05GWDBSRlUwTlNTVkJVU1U5T1hDSTZYQ0pUYVdkdUlHbHVJSFZ6YVc1bklFWnBibWRsY2lCUWNtbHVkRndpTEZ3aVUxUkJWRlZUWENJNlhDSkJRMVJKVmtWY0lpeGNJa05TUlVGVVJVUmZRVlJjSWpwY0lqSXdNakF0TURjdE1qTlVNVEE2TVRJNk5EY3VPRFkzV2x3aUxGd2lRMUpGUVZSRlJGOUNXVndpT2prc1hDSlZVRVJCVkVWRVgwRlVYQ0k2Ym5Wc2JDeGNJbFZRUkVGVVJVUmZRbGxjSWpvNUxGd2lVa1ZUVDFWU1EwVmZRVkJKWDFCQlZFaGNJanB1ZFd4c0xGd2lVRkpKVmtsTVJVZEZYMHhGVmtWTVhDSTZiblZzYkN4Y0lrRkRWRWxQVGx3aU9sd2lkbVZ5YVdaNVhDSXNYQ0pTUlZOUFZWSkRSVjlEUVZSRlIwOVNXVndpT201MWJHd3NYQ0pTUlZOUFZWSkRSVjlYUlVKZlVFRlVTRndpT2x3aVptbHVaMlZ5Y0hKcGJuUmhkWFJvWENKOUxIdGNJa2xFWENJNk5qUXNYQ0pTUlZOUFZWSkRSVjlPUVUxRlhDSTZYQ0pTWldkcGMzUmxjaUJHYVc1blpYSndjbWx1ZEZ3aUxGd2lVa1ZUVDFWU1EwVmZSRVZUUTFKSlVGUkpUMDVjSWpwY0lrWnBibWRsY25CeWFXNTBJRkpsWjJsemRISmhkR2x2YmlCRmJtUndiMmx1ZEZ3aUxGd2lVMVJCVkZWVFhDSTZYQ0pCUTFSSlZrVmNJaXhjSWtOU1JVRlVSVVJmUVZSY0lqcGNJakl3TWpBdE1EZ3RNRFJVTVRRNk1ETTZOVE11TkRReFdsd2lMRndpUTFKRlFWUkZSRjlDV1Z3aU9qa3NYQ0pWVUVSQlZFVkVYMEZVWENJNmJuVnNiQ3hjSWxWUVJFRlVSVVJmUWxsY0lqbzVMRndpVWtWVFQxVlNRMFZmUVZCSlgxQkJWRWhjSWpwdWRXeHNMRndpVUZKSlZrbE1SVWRGWDB4RlZrVk1YQ0k2Ym5Wc2JDeGNJa0ZEVkVsUFRsd2lPbHdpWVdSa1hDSXNYQ0pTUlZOUFZWSkRSVjlEUVZSRlIwOVNXVndpT201MWJHd3NYQ0pTUlZOUFZWSkRSVjlYUlVKZlVFRlVTRndpT2x3aVptbHVaMlZ5Y0hKcGJuUnlaV2RwYzNSeVlYUnBiMjVjSW4wc2Uxd2lTVVJjSWpvMk5TeGNJbEpGVTA5VlVrTkZYMDVCVFVWY0lqcGNJbEJsYm1ScGJtY2dRMjl1YzJsbmJtMWxiblFnVkhKaGJuTmhZM1JwYjI1elhDSXNYQ0pTUlZOUFZWSkRSVjlFUlZORFVrbFFWRWxQVGx3aU9sd2lVR1Z1WkdsdVp5QkRiMjV6YVdkdWJXVnVkQ0JVY21GdWMyRmpkR2x2Ym5OY0lpeGNJbE5VUVZSVlUxd2lPbHdpUVVOVVNWWkZYQ0lzWENKRFVrVkJWRVZFWDBGVVhDSTZYQ0l5TURJeExUQXhMVEl4VkRFd09qRTBPakl4TGpJMk9GcGNJaXhjSWtOU1JVRlVSVVJmUWxsY0lqb3hORE1zWENKVlVFUkJWRVZFWDBGVVhDSTZiblZzYkN4Y0lsVlFSRUZVUlVSZlFsbGNJam94TkRNc1hDSlNSVk5QVlZKRFJWOUJVRWxmVUVGVVNGd2lPbTUxYkd3c1hDSlFVa2xXU1V4RlIwVmZURVZXUlV4Y0lqcHVkV3hzTEZ3aVFVTlVTVTlPWENJNlhDSjJhV1YzWENJc1hDSlNSVk5QVlZKRFJWOURRVlJGUjA5U1dWd2lPbTUxYkd3c1hDSlNSVk5QVlZKRFJWOVhSVUpmVUVGVVNGd2lPbHdpWTI5dWMybG5ibTFsYm5RdmNHVnVaR2x1WjFKbGNYVmxjM1J6WENKOUxIdGNJa2xFWENJNk5EQXNYQ0pTUlZOUFZWSkRSVjlPUVUxRlhDSTZYQ0pXYVdWM0lFbHVkR1Z1ZEhOY0lpeGNJbEpGVTA5VlVrTkZYMFJGVTBOU1NWQlVTVTlPWENJNlhDSldhV1YzSUVsdWRHVnVkSE5jSWl4Y0lsTlVRVlJWVTF3aU9sd2lRVU5VU1ZaRlhDSXNYQ0pEVWtWQlZFVkVYMEZVWENJNlhDSXlNREl3TFRBMkxURTJWREV3T2pRek9qVXhMakEyTUZwY0lpeGNJa05TUlVGVVJVUmZRbGxjSWpvMExGd2lWVkJFUVZSRlJGOUJWRndpT2x3aU1qQXlNQzB3TnkweU1WUXdOem95TURvd01DNHpPREphWENJc1hDSlZVRVJCVkVWRVgwSlpYQ0k2TkN4Y0lsSkZVMDlWVWtORlgwRlFTVjlRUVZSSVhDSTZiblZzYkN4Y0lsQlNTVlpKVEVWSFJWOU1SVlpGVEZ3aU9tNTFiR3dzWENKQlExUkpUMDVjSWpwY0luWnBaWGRjSWl4Y0lsSkZVMDlWVWtORlgwTkJWRVZIVDFKWlhDSTZiblZzYkN4Y0lsSkZVMDlWVWtORlgxZEZRbDlRUVZSSVhDSTZYQ0pwYm5SbGJuUk5ZVzVoWjJWdFpXNTBMMnhwYzNSY0luMHNlMXdpU1VSY0lqbzBOaXhjSWxKRlUwOVZVa05GWDA1QlRVVmNJanBjSWxacFpYY2dTR0Z1Wkc5MlpYSnpYQ0lzWENKU1JWTlBWVkpEUlY5RVJWTkRVa2xRVkVsUFRsd2lPbHdpVm1sbGR5QklZVzVrYjNabGNuTmNJaXhjSWxOVVFWUlZVMXdpT2x3aVFVTlVTVlpGWENJc1hDSkRVa1ZCVkVWRVgwRlVYQ0k2WENJeU1ESXdMVEEyTFRFMlZERXpPakF6T2pRNExqVTBPVnBjSWl4Y0lrTlNSVUZVUlVSZlFsbGNJam8wTEZ3aVZWQkVRVlJGUkY5QlZGd2lPbTUxYkd3c1hDSlZVRVJCVkVWRVgwSlpYQ0k2TkN4Y0lsSkZVMDlWVWtORlgwRlFTVjlRUVZSSVhDSTZiblZzYkN4Y0lsQlNTVlpKVEVWSFJWOU1SVlpGVEZ3aU9tNTFiR3dzWENKQlExUkpUMDVjSWpwY0luWnBaWGRjSWl4Y0lsSkZVMDlWVWtORlgwTkJWRVZIVDFKWlhDSTZiblZzYkN4Y0lsSkZVMDlWVWtORlgxZEZRbDlRUVZSSVhDSTZYQ0pvWVc1a2IzWmxjbk12YkdsemRGd2lmU3g3WENKSlJGd2lPak0zTEZ3aVVrVlRUMVZTUTBWZlRrRk5SVndpT2x3aVZtbGxkeUJEYjI1emFXZHViV1Z1ZEZ3aUxGd2lVa1ZUVDFWU1EwVmZSRVZUUTFKSlVGUkpUMDVjSWpwY0lsWnBaWGNnUTI5dWMybG5ibTFsYm5SY0lpeGNJbE5VUVZSVlUxd2lPbHdpUVVOVVNWWkZYQ0lzWENKRFVrVkJWRVZFWDBGVVhDSTZYQ0l5TURJd0xUQTJMVEUyVkRFd09qUXlPalF4TGprek5scGNJaXhjSWtOU1JVRlVSVVJmUWxsY0lqbzBMRndpVlZCRVFWUkZSRjlCVkZ3aU9sd2lNakF5TUMwd05pMHhObFF4T0RvMU1UbzBNUzR4TURKYVhDSXNYQ0pWVUVSQlZFVkVYMEpaWENJNk5DeGNJbEpGVTA5VlVrTkZYMEZRU1Y5UVFWUklYQ0k2Ym5Wc2JDeGNJbEJTU1ZaSlRFVkhSVjlNUlZaRlRGd2lPbTUxYkd3c1hDSkJRMVJKVDA1Y0lqcGNJblpwWlhkY0lpeGNJbEpGVTA5VlVrTkZYME5CVkVWSFQxSlpYQ0k2Ym5Wc2JDeGNJbEpGVTA5VlVrTkZYMWRGUWw5UVFWUklYQ0k2WENKamIyNXphV2R1YldWdWRDOXNhWE4wWENKOUxIdGNJa2xFWENJNk1UQXlMRndpVWtWVFQxVlNRMFZmVGtGTlJWd2lPbHdpVW1WamIyNWphV3hsSUZOMGIyTnJJRUpoYkdGdVkyVmNJaXhjSWxKRlUwOVZVa05GWDBSRlUwTlNTVkJVU1U5T1hDSTZYQ0pTWldOdmJtTnBiR1VnVTNSdlkyc2dRbUZzWVc1alpWd2lMRndpVTFSQlZGVlRYQ0k2WENKQlExUkpWa1ZjSWl4Y0lrTlNSVUZVUlVSZlFWUmNJanBjSWpJd01qTXRNRGt0TWpKVU1EYzZOVGM2TkRjdU5USTRXbHdpTEZ3aVExSkZRVlJGUkY5Q1dWd2lPall5TEZ3aVZWQkVRVlJGUkY5QlZGd2lPbTUxYkd3c1hDSlZVRVJCVkVWRVgwSlpYQ0k2TmpJc1hDSlNSVk5QVlZKRFJWOUJVRWxmVUVGVVNGd2lPbTUxYkd3c1hDSlFVa2xXU1V4RlIwVmZURVZXUlV4Y0lqcHVkV3hzTEZ3aVFVTlVTVTlPWENJNlhDSjJhV1YzWENJc1hDSlNSVk5QVlZKRFJWOURRVlJGUjA5U1dWd2lPbTUxYkd3c1hDSlNSVk5QVlZKRFJWOVhSVUpmVUVGVVNGd2lPbHdpWW1Gc1lXNWpaWE12Y21WamIyNWphV3hwWVhScGIyNWNJbjFkSWl3aVVrOU1SVjlPUVUxRklqb2lVMWxUUVdSdGFXNGlMQ0pVVDB0RlRsOUVSVlJCU1V4VElqcDdJbVY0Y0NJNk1UY3dNalExT1RBNE1DNDVNekVzSW1saGRDSTZNVGN3TWpRMU9EazJNSDE5Llk5TVN5TmM4WWNrTUZXaTBXNVFyNnFUTXBXR1VEcVpjY0hDQW1DdlMtZlkiLCJpYXQiOjE3MDI0NTg5NjB9.4qHBmaYszZr6JChtRKxt09hNI8k2jUy_xbxzP5xjXq8"
      }
        sessionStorage.setItem("expiresIn", data.expiresIn);
        let userInfo = JSON.parse(tokenDecode(data.user_data));
        if (userInfo.MFA_TYPE !== null) {
          //MFA set for this user
          sessionStorage.setItem("usr", data.user_data);
          sessionStorage.setItem("tempToken", data.access_token);
          dispatch({ type: TEMPORARY_USER_TOKEN, payload: data.access_token });
        } else {
          //MFA not set for this user
          sessionStorage.setItem("user", JSON.stringify(userInfo));
          sessionStorage.setItem("createResp", 'success');
          sessionStorage.setItem("mfa", 'valid');
          sessionStorage.setItem("token", data.access_token);
          dispatch({ type: USER_DATA, payload: userInfo });
          dispatch({ type: USER_TOKEN_SET, payload: data.user_data });
        }
      // } else {
      //   dispatch({ type: SHOW_MESSAGE, payload: 'Failed to login invalid credentials' });
//       // }
//     }).catch(function (error) {
//         dispatch({ type: SHOW_MESSAGE, payload: 'Error occured.' });
//       //alert(JSON.stringify(error.message))
//       if (error.message == 'Request failed with status code 409') {
//         dispatch({ type: FETCH_ERROR, payload: "User is Inactive" });
//       } else if (error.message == 'Request failed with status code 408') {
//         dispatch({ type: FETCH_ERROR, payload: "User is blocked" });
//       } else if (error.message == 'Request failed with status code 407') {
//         dispatch({ type: FETCH_ERROR, payload: "Wrong password" });
//       } else if (error.message == 'Request failed with status code 404') {
//         dispatch({ type: FETCH_ERROR, payload: "User not found" });
//       }else if (error.message == 'Request failed with status code 704') {
//         dispatch({ type: FETCH_ERROR, payload: "User already signed in other device. Please Sign out first" });
//       } else {
//         dispatch({ type: FETCH_ERROR, payload: "Failed to Signin" });
//       }
//     });
  }
};

export const forgotPasword = ({ email }) => {
  //alert(email)//
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    adminAPI.post('requestnewpassword', {
      USERNAME: email
    }
    ).then(({ data }) => {
      dispatch({ type: FETCH_SUCCESS });

      if (data.success === true) {
        //alert(JSON.stringify(data.success))
        //sessionStorage.setItem('resetPasswordAccepted', 'true');
        dispatch({ type: SHOW_MESSAGE, payload: 'Password reset link sent to your email' });
      } else {
        //alert("No User")
        //sessionStorage.setItem('resetPasswordAccepted', 'false');
        dispatch({ type: FETCH_ERROR, payload: 'User not found' });
        //dispatch({ type: SHOW_MESSAGE, payload: 'User not found' });

      }
    }).catch(function (error) {
      dispatch({ type: FETCH_ERROR, payload: 'Sorry something went wrong' });
    });
  }
};

export const resetPassword = ({ email, otp, password }) => {
  //alert(email)
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    adminAPI.put('changepassword', {
      USERNAME: email,
      OTP: otp,
      NEW_PASSWORD: password
    }
    ).then(({ data }) => {
      dispatch({ type: FETCH_SUCCESS });
      // alert(JSON.stringify(data.errorInformation.extensionList[0].value))
      //alert(JSON.stringify(data))
      if (data.success === true) {
        //alert(JSON.stringify(data.success))
        //sessionStorage.setItem('changePasswordAccepted', 'true');
        dispatch({ type: SHOW_MESSAGE, payload: 'Password reset successfully' });
      } else {
        //alert("No User")
        //sessionStorage.setItem('changePasswordAccepted', 'false');
        dispatch({ type: FETCH_ERROR, payload: data.errorInformation.extensionList[0].value });

      }
    }).catch(function (error) {
      //alert(JSON.stringify(error))
      //sessionStorage.setItem('changePasswordAccepted', 'false');
      if (error.message == 'Request failed with status code 409') {
        dispatch({ type: FETCH_ERROR, payload: 'Must not repeat 3 previous passwords' });
      } else {
        dispatch({ type: FETCH_ERROR, payload: 'Failed to reset password' });
      }

    });
  }
};

export const getUser = () => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    adminAPI.post('auth/me',
    ).then(({ data }) => {
      //console.log("userSignIn: ", data);
      if (data) {
        dispatch({ type: FETCH_SUCCESS });
        dispatch({ type: USER_DATA, payload: data });
      } else {
        dispatch({ type: FETCH_ERROR, payload: data.error });
      }
    }).catch(function (error) {
      dispatch({ type: FETCH_ERROR, payload: error.message });
      //console.log("Error****:", error.message);
    });
  }
};


export const userSignOutOld = () => {

  let user = JSON.parse(sessionStorage.getItem('user'))

  let token = sessionStorage.getItem('token');
   
    const _data = {
       headers: {
           Authorization: `Bearer ${token}`,
       }
    };

  return (dispatch) => {
    dispatch({ type: FETCH_START });
    adminAPI.post('logout',
      {
        USERNAME: user.USERNAME,
        BIO_INFO: (user.BIO_INFO) ? user.BIO_INFO : ""
      }
    ).then(({ data }) => {
      if (data) {
        dispatch({ type: FETCH_SUCCESS });
        sessionStorage.removeItem("token");
        dispatch({ type: FETCH_SUCCESS });
        dispatch({ type: SIGNOUT_USER_SUCCESS });
        dispatch({ type: USER_DATA, payload: null });
      } else {
        dispatch({ type: FETCH_ERROR, payload: "data.error" });
      }
    }).catch(function (error) {
      dispatch({ type: FETCH_ERROR, payload: error.message });
     // console.log("Error****:", error.message);
    });
  }
};


export const userSignOut = () => {

  let user = JSON.parse(sessionStorage.getItem('user'))
  //console.log(" user ",user);
  // if(!user || user.ID == null){
  //   // return (<Redirect from='*' to={'/signin'} />);
  //   // return (<Redirect to={'/app/signin'} />);
  // }
  

  let token = sessionStorage.getItem('token');

  //console.log('hapa',sessionStorage.getItem('token'))
  //alert(sessionStorage.getItem('token'))
   
    const _data = {
      params: null,
        headers: {
          'Content-Type': 'application/json',
          'Accept':'application/json',
          'Authorization' : `Bearer ${token}`,
        }
      // data: {}
    };

  return (dispatch) => {
    dispatch({ type: FETCH_START });
    let userObj = {}
     sessionStorage.clear();
     sessionStorage.clear();
    userObj = (user)? {ID: user.ID,USERNAME: user.USERNAME,BIO_INFO: (user.BIO_INFO) ? user.BIO_INFO : ""}:userObj;
    adminAPI.post('logout',userObj,_data
    ).then(({ data }) => {
      
      if (data) {
        dispatch({ type: FETCH_SUCCESS });
       
        dispatch({ type: USER_TOKEN_SET, payload: null });
        //sessionStorage.removeItem("token");
        dispatch({ type: FETCH_SUCCESS });
        dispatch({ type: SIGNOUT_USER_SUCCESS });
        dispatch({ type: USER_DATA, payload: null });
        dispatch({ type: INTENT_INIT });//Resets intent state
      } else {
        dispatch({ type: FETCH_ERROR, payload: "data.error" });
      }
    }).catch(function (error) {
      //console.log('Imegoma',error)
      //alert('Imegoma '+error)
      dispatch({ type: FETCH_ERROR, payload: error.message });
      //console.log("Error****:", error.message);
    });
  }
};



export const hasAccess = (webPath, webAction) => {
  //this.state
  //console.log('Global State',store.getState())
  // alert(JSON.stringify(store.getState().auth.authUser))
  //let userToken = store.getState().auth.authUser;
  //let resources = (userToken) ? store.getState().auth.authUser : null
   let userToken = sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')).TOKEN : null;
   let resources = (userToken) ? tokenDecode(userToken) : null
  let resourcesArry = (resources) ? JSON.parse(JSON.parse(resources).RESOURCE_GROUP) : [];
  //console.log('resourcesArry',resourcesArry)
  //let isTrue = false;
  let isTrue = {
    [webAction]: true
  };

  // if (resourcesArry) {
  //   for (let index = 0; index <= resourcesArry.length; index++) {
  //     // if (resourcesArry[index] && resourcesArry[index].RESOURCE_WEB_PATH == webPath && webPath == 'consignment/pendingRequests') {
  //     //     alert(resourcesArry[index].RESOURCE_WEB_PATH)
  //     // }
  //     if (resourcesArry[index] && resourcesArry[index].RESOURCE_WEB_PATH == webPath) {
  //       //isTrue = true;    
  //       isTrue = {
  //         [webAction]: true
  //       };
  //     }

  //   }
  // }
  return isTrue;
};


export const getCurrentUserLevel = () => {
  let currentUserLevel = {
    isOriginator: false,
    isVerifier: false,
    // isAuthorizer: false,
    isAuthorizer: true,
    isSYSAdmin: false,
  };
  if (getUserDetails() && (getUserDetails().USER_LEVEL_ESB == 3 || getUserDetails().USER_LEVEL_ESB == 4)) {
    currentUserLevel.isOriginator = true;
  } if (getUserDetails() && (getUserDetails().USER_LEVEL_ESB == 5 || getUserDetails().USER_LEVEL_ESB == 6)) {
    currentUserLevel.isVerifier = true;
  } if (getUserDetails() && (getUserDetails().USER_LEVEL_ESB == 8)) {
    currentUserLevel.isAuthorizer = true;
  } if (getUserDetails() && (getUserDetails().USER_LEVEL_ESB == 9)) {
    currentUserLevel.isSYSAdmin = true;
  }
  // alert(JSON.stringify(currentUserLevel))
  return currentUserLevel;



}

export const isSCC = () => {
  let userToken = sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : null;

  let ROLE_ID = (userToken) ? userToken.ROLE_ID : 0;
  let isTrue = false;
  if (ROLE_ID == 4 || ROLE_ID == 8) {
    isTrue = true
  }
  return isTrue;
};

export const isAdmin = () => {
  let userToken = sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : null;

  let ROLE_ID = (userToken) ? userToken.ROLE_ID : 0;
  let isTrue = false;
  if (ROLE_ID == 21) {
    isTrue = true
  }
  return isTrue;
};

export const isSCCBranchManager = () => {
  let userToken = sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : null;

  let ROLE_ID = (userToken) ? userToken.ROLE_ID : 0;
  let isTrue = false;
  if (ROLE_ID == 61) {
    isTrue = true
  }
  return isTrue;
};

export const isAuditor = () => {
  let userToken = sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : null;

  let ROLE_ID = (userToken) ? userToken.ROLE_ID : 0;
  let isTrue = false;
  if (ROLE_ID == 62) {
    isTrue = true
  }
  return isTrue;
};


export const isSCCReserve = () => {
  let userToken = sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : null;
  let ROLE_ID = (userToken) ? userToken.ROLE_ID : 0;
  let isTrue = false;
  if (ROLE_ID == 8) {
    isTrue = true
  }
  return isTrue;
};

export const isCommercial = () => {
  let userToken = sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : null;
  //console.log('RCS -',userToken)
  let ROLE_ID = (userToken) ? userToken.ROLE_ID : 0;
  let isTrue = false;
  if (ROLE_ID >= 1 && ROLE_ID <= 3) {
    isTrue = true
  }
  return isTrue;
};

export const getUserDetails = () => {
  //authUser
  //console.log('Global State',store.getState())
  // alert(JSON.stringify(store.getState().auth.authUser))
  //let userToken = store.getState().auth.authUser;
  let userToken = sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : null;
  let userData = (userToken) ? userToken : null
  // console.log('userData',userData)
  return userData;
};

export const countUpperCaseChars = (str) => {
  var count = 0, len = str.length;
  for (var i = 0; i < len; i++) {
    if (/[A-Z]/.test(str.charAt(i))) count++;
  }
  //alert(count)
  return count;
}

export const countLowerCaseChars = (str) => {
  var count = 0, len = str.length;
  for (var i = 0; i < len; i++) {
    if (/[a-z]/.test(str.charAt(i))) count++;
  }
  //alert(count)
  return count;
}

export const countSpecialChars = (str) => {
  //var sectionToCheck  = "$%klds$"; 
  var count = 0;
  var allFoundCharacters = str.match(/[@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g);
  count = (allFoundCharacters) ? allFoundCharacters.length : 0;
  ////alert(count);

  return count;
}

export const countDigits = (str) => {
  //alert(str.replace(/[^0-9]/g,"").length);
  var count = str.replace(/[^0-9]/g, "").length;
  return count;
}

export const validateWithPasswordPolicy = (str, usedPolicy) => {
  let responseMessage = null;
  if (usedPolicy && usedPolicy.MINIMUM_UPPER_CASE > countUpperCaseChars(str)) {
    responseMessage = 'Password must have atleast ' + usedPolicy.MINIMUM_UPPER_CASE + ' capital letters';
    return responseMessage;
  } else if (usedPolicy && usedPolicy.MINIMUM_LOWER_CASE > countLowerCaseChars(str)) {
    responseMessage = 'Password must have atleast ' + usedPolicy.MINIMUM_LOWER_CASE + ' small letters';
    return responseMessage;
  } else if (usedPolicy && usedPolicy.MINIMUM_DIGITS > countDigits(str)) {
    responseMessage = 'Password must have atleast ' + usedPolicy.MINIMUM_DIGITS + ' integers';
    return responseMessage;
  } else if (usedPolicy && usedPolicy.MINIMUM_SPECIAL_CHARACTERS > countSpecialChars(str)) {
    responseMessage = 'Password must have atleast ' + usedPolicy.MINIMUM_SPECIAL_CHARACTERS + ' special characters';
    return responseMessage;
  } else {
    return responseMessage;
  }

}
